import Evaluations from '@src/main/modules/reports/ui/components/Evaluations';

const EvaluationsPage = () => <Evaluations />;

export default EvaluationsPage;
